import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const PregnanciesWeeks = () => {
    const { chartData } = useCurrentPregnancyChartsDataContext();


    return (
        <SimpleBars
            title={'Semanas de Gestação'}
            horizontal={false}
            subtitles={chartData?.pregnanciesWeeks?.map((item) => item.description)}
            values={chartData?.pregnanciesWeeks?.map((item) => item.total  ||  0)}
        />
    );
};
